const types = new Set(['application/pdf', 'image/png', 'image/jpeg']);
const changed = () => new Error('Los diseños o la solicitud cambiaron en Ventas. Vuelve a cargar la solicitud antes de preparar el RFQ.');

// Fetch binary content only on Prepare, through the existing permission-scoped CRM read.
// The polling inbox continues to carry metadata only.
export async function loadReferenceFiles(request, salesApi) {
    if (!request?.products?.some(p => p.attachments?.length)) return [];
    const detail = await salesApi(`/opportunities/${encodeURIComponent(request._id)}`);
    if (String(detail?._id) !== String(request._id) || detail.businessUnit !== 'empaque' || detail.stage !== 'pricing' ||
        (detail.revision || 0) !== request.revision || String(detail.updatedAt) !== String(request.updatedAt)) throw changed();
    const result = [];
    let total = 0;
    for (const line of request.products) {
        const source = detail.products?.[line.sourceLine];
        if (!source || source.productId !== line.productId || (source.attachments || []).length !== (line.attachments || []).length) throw changed();
        for (const [index, metadata] of (line.attachments || []).entries()) {
            const attachment = source.attachments[index];
            if (attachment.name !== metadata.name || attachment.mime !== metadata.mime || !types.has(attachment.mime) || typeof attachment.data !== 'string' || attachment.data.length > 1400000) throw changed();
            let bytes;
            try { bytes = Uint8Array.from(atob(attachment.data), c => c.charCodeAt(0)); } catch (_) { throw changed(); }
            total += bytes.length;
            if (!bytes.length || bytes.length > 1024 * 1024 || total > 3 * 1024 * 1024) throw new Error('No se pudieron cargar los diseños de Ventas: tamaño de archivo inválido.');
            result.push({id: `sales-${line.sourceLine}-${index}`, file: new File([bytes], attachment.name, {type: attachment.mime}), source: `Ventas · ${line.productName}`});
        }
    }
    return result;
}

export const supplierEmail = supplier => supplier.emails?.[0] || supplier.contacts?.find(c => c.email)?.email || '';
export function parseRecipients(value) {
    const emails = [...new Set(String(value || '').split(/[;,\s]+/).map(s => s.trim()).filter(Boolean).map(s => s.toLowerCase()))];
    return {emails, valid: emails.length > 0 && emails.every(email => email.length <= 254 && /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email))};
}
